import './App.css';
import ModernNavbar from "./components/navbar/Navbar.modern"
import ModernFooter from './components/footer/Footer.modern';
import ModernHomepage from './components/landing page/Homepage.modern';
import React, { useEffect } from 'react';
import SingleProduct from './components/single-product-page/singleProductpage';
import ModernCart from './components/cart/cart.modern';
import ModernProductListing from './components/product-page/ProductListing.modern';
import GroupedProductListing from './components/product-page/GroupedProductListing';
import ProductGroupDetail from './components/product-page/ProductGroupDetail';
import ModernBrandProducts from './components/product-page/BrandProducts.modern';
import CategoryProducts from './components/product-page/CategoryProducts';
import BestSellers from './components/product-page/BestSellers';
import ModernLogin from './components/login-signup/Login.modern'
import SetPassword from './components/login-signup/SetPassword'
import ManagementLayout from './components/management/ManagementLayout'
import Dashboard from './components/management/Dashboard'
import ManagementProducts from './components/management/Products'
import CreateProductCombo from './components/management/CreateProductCombo'
import ProductImport from './components/management/ProductImport'
import ManagementOrders from './components/management/Orders'
import ManagementCustomers from './components/management/Customers'
import ChatInbox from './components/management/ChatInbox'
import Promotions from './components/management/Promotions'
import Collections from './components/management/Collections'
import ProductGrouping from './components/management/ProductGrouping'
import Settings from './components/management/Settings'
import BestSellersMgmt from './components/management/BestSellers'
import Content from './components/management/Content'
import Inventory from './components/management/Inventory'
import Discounts from './components/management/Discounts'
import BrandPriceManager from './components/management/BrandPriceManager'
import PageRenderer from './components/pages/PageRenderer'
import AdminDashboard from './components/admin/AdminDashboard'
import Checkout1 from './components/payment-checkout/checkOut1';
import Checkout from './components/payment-checkout/Checkout';
import { Routes, Route, Navigate, useLocation } from "react-router-dom"
import ThankYOu from './components/payment-checkout/thankYou';
// /import AboutUs from './components/about/AboutUs';
import Orders from './components/orders/Orders';
import OrderDetail from './components/orders/OrderDetail';
import ChatWidget from './components/chat/ChatWidget';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Protected route for management (admin and staff)
const ManagementRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = localStorage.getItem('token');
  
  if (!token || (user.role !== 'admin' && user.role !== 'staff')) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

// Protected route for admin only
const AdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = localStorage.getItem('token');
  
  if (!token || user.role !== 'admin') {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

// Protected route for authenticated users
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

function App() {
  const location = useLocation();
  const isManagementRoute = location.pathname.startsWith('/management');

  return (
    <div>
      <ScrollToTop />
      {!isManagementRoute && <ModernNavbar />}
      <Routes >
        <Route path='/' element={<ModernHomepage />} />
        <Route path='/about' element={<PageRenderer />} />
        <Route path='/contact' element={<PageRenderer />} />
        <Route path='/shipping' element={<PageRenderer />} />
        <Route path='/returns' element={<PageRenderer />} />
        <Route path='/faq' element={<PageRenderer />} />
        <Route path='/privacy' element={<PageRenderer />} />
        <Route path='/terms' element={<PageRenderer />} />
        <Route path='/login' element={<ModernLogin />} />
        <Route path='/signup' element={<ModernLogin />} />
        <Route path='/set-password' element={<SetPassword />} />
        <Route path='/products' element={<ModernProductListing />} />
        <Route path='/shop' element={<GroupedProductListing />} />
        <Route path='/product-group/:groupId' element={<ProductGroupDetail />} />
        <Route path='/brands/:brandSlug' element={<ModernBrandProducts />} />
        <Route path='/category/:categorySlug' element={<CategoryProducts />} />
        <Route path='/best-sellers' element={<BestSellers />} />
        <Route path="/products/:id" element={<SingleProduct />} />
        <Route path="/cart" element={
          <ProtectedRoute>
            <ModernCart />
          </ProtectedRoute>
        } />
        <Route path='/checkout' element={
          <ProtectedRoute>
            <Checkout1 />
          </ProtectedRoute>
        } />
        <Route path="/checkout2" element={
          <ProtectedRoute>
            <Checkout />
          </ProtectedRoute>
        } />
        <Route path="/thankyou" element={
          <ProtectedRoute>
            <ThankYOu />
          </ProtectedRoute>
        } />
        <Route path='/orders' element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        } />
        <Route path='/orders/:id' element={
          <ProtectedRoute>
            <OrderDetail />
          </ProtectedRoute>
        } />

        {/* Management Routes (Admin & Staff) */}
        <Route path='/management' element={
          <ManagementRoute>
            <ManagementLayout />
          </ManagementRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path='orders' element={<ManagementOrders />} />
          <Route path='products' element={<ManagementProducts />} />
          <Route path='create-product-combo' element={<CreateProductCombo />} />
          <Route path='product-import' element={<ProductImport />} />
          <Route path='grouping' element={<ProductGrouping />} />
          <Route path='inventory' element={<Inventory />} />
          <Route path='customers' element={<ManagementCustomers />} />
          <Route path='chat' element={<ChatInbox />} />
          <Route path='promotions' element={<Promotions />} />
          <Route path='collections' element={<Collections />} />
          <Route path='discounts' element={<Discounts />} />
          <Route path='pricing' element={<BrandPriceManager />} />
          <Route path='best-sellers' element={<BestSellersMgmt />} />
          <Route path='shipping' element={<div style={{padding: '20px'}}>Shipping Settings (Coming Soon)</div>} />
          <Route path='content' element={<Content />} />
          <Route path='staff' element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } />
          <Route path='reports' element={
            <AdminRoute>
              <div style={{padding: '20px'}}>Reports & Analytics (Coming Soon)</div>
            </AdminRoute>
          } />
          <Route path='settings' element={
            <AdminRoute>
              <Settings />
            </AdminRoute>
          } />
        </Route>

        {/* Legacy Admin Route - Redirect to Management */}
        <Route path='/admin' element={<Navigate to="/management/staff" replace />} />
      </Routes>
      {!isManagementRoute && <ModernFooter />}
      {!isManagementRoute && <ChatWidget />}
    </div>
  );
}

export default App;
